import { ensureBoolean, ensureColor, ensureFloat, ensureInt } from "../../utils/TypeUtils";
import { RoundRectTexture } from "tree2d";
import { DynamicSizeTexture } from "./DynamicSizeTexture";
export class StyledRectangle extends DynamicSizeTexture {
    constructor(stage) {
        super(stage);
        this.options = {};
        this.roundRectTexture = new RoundRectTexture(this.stage);
        this.textureElement.texture = this.roundRectTexture;
    }
    get radius() {
        return this.options["radius"] ? this.options["radius"][0] : 0;
    }
    set radius(radius) {
        const r = ensureFloat(radius);
        this.setOption("radius", [r, r, r, r]);
    }
    get "stroke-width"() {
        return this.options["strokeWidth"] ? this.options["strokeWidth"] : 0;
    }
    set "stroke-width"(v) {
        this.setOption("strokeWidth", ensureInt(v));
    }
    get "stroke-color"() {
        return this.options["strokeColor"] ? this.options["strokeColor"] : 0xffffffff;
    }
    set "stroke-color"(v) {
        this.setOption("strokeColor", ensureColor(v));
    }
    get fill() {
        return this.options["fill"] ? this.options["fill"] : true;
    }
    set fill(v) {
        this.setOption("fill", ensureBoolean(v));
    }
    get "fill-color"() {
        return this.options["fillColor"] ? this.options["fillColor"] : 0xffffffff;
    }
    set "fill-color"(v) {
        this.setOption("fillColor", ensureColor(v));
    }
    get "shadow-blur"() {
        return this.options["shadowBlur"] ? this.options["shadowBlur"] : 0;
    }
    set "shadow-blur"(v) {
        this.setOption("shadowBlur", ensureFloat(v));
    }
    get "shadow-color"() {
        return this.options["shadowColor"] ? this.options["shadowColor"] : 0xffffffff;
    }
    set "shadow-color"(v) {
        this.setOption("shadowColor", ensureColor(v));
    }
    get "shadow-offset-x"() {
        return this.options["shadowOffsetX"] ? this.options["shadowOffsetX"] : 0;
    }
    set "shadow-offset-x"(v) {
        this.setOption("shadowOffsetX", ensureFloat(v));
    }
    get "shadow-offset-y"() {
        return this.options["shadowOffsetY"] ? this.options["shadowOffsetY"] : 0;
    }
    set "shadow-offset-y"(v) {
        this.setOption("shadowOffsetY", ensureFloat(v));
    }
    updateDimensions(w, h) {
        this.options.w = w;
        this.options.h = h;
        this.updateRoundedRectangleTextureOptions();
    }
    setOption(property, value) {
        this.options[property] = value;
        this.updateRoundedRectangleTextureOptions();
    }
    updateRoundedRectangleTextureOptions() {
        this.roundRectTexture.options = this.options;
    }
    handleResize(element, w, h) {
        if (this.options) {
            this.updateDimensions(w, h);
        }
    }
}
//# sourceMappingURL=StyledRectangle.js.map